import React from "react";
import Button from "../../../../components/Button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CloseArenaDialog } from "../../../../redux/arena-dialog/action";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
type Props = {};

const CampBoxEmptyState: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const { t } = useAppTranslation("battle");
  function handleClick() {
    dispatch(CloseArenaDialog());
  }
  return (
    <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
      <div className="dark-yellow">{t("campEmpty.noTroops")}</div>
      <Link onClick={handleClick} to="/barracks">
        <Button variant="default" className="bg-100 text-yellow-2 px-lg-3 ">
          {t("campEmpty.addTroops")}
        </Button>
      </Link>
    </div>
  );
};

export default CampBoxEmptyState;
